export const tarifConstants = {
	GetTarifs: {
		REQUEST : 'GET_TARIF_REQUEST',
		SUCCESS : 'GET_TARIF_SUCCESS',
		FAILURE : 'GET_TARIF_FAILURE'
	},
	UpdateTarifs: {
		REQUEST : 'UPDATE_TARIF_REQUEST',
		SUCCESS : 'UPDATE_TARIF_SUCCESS',
		FAILURE : 'UPDATE_TARIF_FAILURE'
	},
	ClearTarifs: 'CLEAR_TARIF'
}
